import { useState } from "react";

export default function Manage(props: any) {
  const [progress, setProgress] = useState("");

  
  return (
    <div>
      <div>
        <input 
          type="file"
          onClick={(e: any) => {
            e.target.value = null;
          }}
          onChange={async (e: any) => {
            let file = e.target?.files?.[0];
            if (!file) return console.log("No file");
            const arrayBuffer = await new Promise((resolve, reject) => {
              let reader = new FileReader();
              reader.onload = () => {
                resolve(reader.result);
              };
              reader.onerror = reject;
              reader.readAsArrayBuffer(file);
            });
            if (arrayBuffer) {
              props.onEvent({message: "GenInformatics", 
                params: {arrayBuffer, setProgress}});
            }
          }}
        />
      </div>
      <div>{progress}</div>
    </div>
  )
}

// import {parse, stringify} from "smol-toml";
// let result = parse(`
//   [ymd]
//   cid = 0
//   type = "VARCHAR"
//   notnull = false
//   pk = false

//   [ym]
//   cid = 1
//   type = "VARCHAR"
//   notnull = false
//   pk = false
//   dim = true
//   time = true

//   [id]
//   cid = 2
//   type = "VARCHAR"
//   notnull = false
//   pk = false
//   agg = [ "count",]

//   [first]
//   cid = 2
//   type = "VARCHAR"
//   notnull = false
//   pk = false
//   dim = true

//   [last]
//   cid = 3
//   type = "VARCHAR"
//   notnull = false
//   pk = false
//   dim = true

//   [span]
//   cid = 4
//   type = "BIGINT"
//   notnull = false
//   pk = false
//   dim = true
//   `);
